import { useState, useEffect } from 'react';
import useOrgStore from '../store/zustand/useOrgStore';
import { CircleLevelPartial } from '../_types/types.type';
// import fetchCircleLevels from '../utils/fetchFunctions/fetchCircleLevels';
import fetchCircleLevels from '../utils/fetchFunctions/fetchCircleLevels';

export default function useCircleLevels() {
  //  @ts-ignore
  const orgID = global.me.orgID;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const setCircleLevels = useOrgStore((state) => state.setCircleLevels);
  const circleLevels: CircleLevelPartial[] = useOrgStore(
    (state) => state.circleLevels
  );

  useEffect(() => {
    const fetchAndStoreCircleLevels = async () => {
      // Only fetch if we don't have data yet
      if (circleLevels.length > 0) {
        return;
      }

      try {
        setIsLoading(true);
        const fetchedCircleLevels = await fetchCircleLevels();
        setCircleLevels(fetchedCircleLevels);
        setIsLoading(false);
      } catch (err) {
        setError(JSON.stringify(err));
      } finally {
        setIsLoading(false);
      }
    };

    fetchAndStoreCircleLevels();
  }, [orgID, circleLevels.length]);

  return { isLoading, error, circleLevels };
}
